import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            精选动漫剪辑与MAD混剪，感受动漫的魅力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-2xl ml-1"></i>
                  </div>
                </div>
                {/* Duration */}
                <span className="absolute bottom-3 right-3 px-2.5 py-1 bg-black/65 text-white text-xs rounded-md whitespace-nowrap backdrop-blur-sm">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-foreground-500">
                  <i className="ri-eye-line text-sm"></i>
                  <span className="text-xs">{item.views} 次播放</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}